'use client'

import { getCart } from '@/lib/actions'
import { useAppDispatch } from '@/lib/hooks'
import { setCart as setCartAction } from '@/lib/redux'
import { toast } from 'sonner'

interface UpdateOrderPropertiesPayload {
  cartId: string
  pickup_time: string
  fulfillment_time: string
  order_source: string
  delivery_method: string
}

export const useOrderProperties = () => {
  const dispatch = useAppDispatch()

  const updateOrderProperties = (
    payload: UpdateOrderPropertiesPayload,
  ) => {
    return new Promise((resolve, reject) => {
      const worker = new Worker(
        new URL('@/lib/workers/order-properties.worker', import.meta.url),
      )

      worker.postMessage({
        type: 'UPDATE_ORDER_PROPERTIES',
        payload,
      })

      worker.onmessage = async (event) => {
        const { type, error } = event.data

        if (type === 'ERROR') {
          toast.error(error || 'Failed to update order properties')
          worker.terminate()
          reject(error)
          return
        }

        if (type === 'SUCCESS') {
          try {
            // Refresh cart from server to get latest data
            const cart = await getCart(payload.cartId)
            dispatch(setCartAction(cart))
            toast.success('Order properties updated successfully')
            worker.terminate()
            resolve(cart)
          } catch (error: any) {
            toast.error('Failed to refresh cart')
            worker.terminate()
            reject(error)
          }
        }
      }

      worker.onerror = (error) => {
        console.error('Worker error:', error)
        toast.error('An error occurred while updating order properties')
        worker.terminate()
        reject(error)
      }
    })
  }

  return {
    updateOrderProperties,
  }
}
